import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';

import UploadBox from './UploadBox';
import operations from '../operations';
import constants from '../../../constants';

type DropzoneProps = {
  children: React.ReactNode,
}

const Dropzone: React.FC<DropzoneProps> = ({
  children,
}) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const onDrop = useCallback((acceptedFiles) => {
    void dispatch(operations.uploadSelectedFilesAndRefreshGroups(acceptedFiles));
  }, [dispatch]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'application/octet-stream': [...constants.ALLOWED_UPLOAD_FILE_TYPES],
    },
    noClick: true,
    noDragEventsBubbling: true,
    noKeyboard: true,
    onDrop,
  });

  const childrenWithProps = React.isValidElement(children) ?
    React.cloneElement(
      children as React.ReactElement,
      { uploadBox: <UploadBox isDragActive={isDragActive} /> },
    ) :
    null;

  return (
    <div
      {...getRootProps()}
      className="relative min-h-full"
    >
      <input
        {...getInputProps()}
      />
      {isDragActive && (
        <div className="
        absolute h-full w-full
        flex justify-center items-center
        border-2 border-dashed border-blue-700
        bg-opacity-5 bg-blue-700"
        />
      )}
      <div className={classNames({
        'pointer-events-none': isDragActive,
      })}
      >
        {childrenWithProps}
      </div>
    </div>
  );
};

export default Dropzone;
